
import Analysis from '@/components/Company/Analysis'

export default {
    name: 'StockThemeChart',
    components: {
        Analysis,
    },
}
